import React, { useEffect, useState } from "react";
import BasicDataTable from "../../../Component/BasicComponents/BasicDataTable";
import { RiPencilFill } from "react-icons/ri";
import { FaEdit, FaEye } from "react-icons/fa";
import RoundedDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdown";
import { useLocation, useNavigate } from "react-router-dom";
import CustomerModal from "./Modal/CustomerModal";
import RouteModal from "../../../Component/BasicComponents/Modal/RouteModal";
import { Link } from "react-router-dom";
import { Col, Container, Row } from "reactstrap";
import { useAllTowns, useOutletList, useOutletType } from "./hooks/useCustomer";
import {
  useAllPositionList,
  useGetOrgUnitsData,
} from "../../Employee/hooks/useEmployee";
import { useClassificationListData } from "../Classification/hooks/useClassification";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getAllPositionList } from "../../Employee/hooks/EmployeeRepository";
import CustomDropdown from "../../../Component/BasicComponents/Dropdowns/RoundedDropdownPagination";
import { getAllTerritory } from "../../FSM/Beats_Patches/hooks/BeatRepository";

const HeaderContent = (props: any) => {
  const handleFilter = (key: any, selected: any) => {
    const parsedId =
      typeof selected === "object"
        ? selected?.id === "null"
          ? null
          : Number(selected?.id) || selected?.id
        : selected === "null"
        ? null
        : Number(selected) || selected;

    props?.setFiltersState((prev: any) => ({
      ...prev,
      [key]: parsedId,
    }));
  };

  // const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <Container>
      <Row className="d-flex justify-content-end align-items-center flex-md-row flex-column">
        <Col md="auto" xs="12">
          <RoundedDropdown
            options={props?.orgUnitsList || []}
            onSelect={(e) => handleFilter("orgUnit", e)}
            defaultLabel="All"
            width="auto"
            height="25px"
            isShowHeading
            DropdownHeading="Org Unit"
            headingColor="#2e8dd3"
          />
        </Col>
        <Col md="auto" xs="12">
          <RoundedDropdown
            options={props?.outletType || []}
            onSelect={(e) => handleFilter("outletType", e)}
            defaultLabel="All"
            width="auto"
            height="25px"
            isShowHeading
            DropdownHeading="Outlet Type"
            headingColor="#2e8dd3"
          />
        </Col>
        <Col md="auto" xs="12">
          <RoundedDropdown
            options={props?.classification || []}
            onSelect={(e) => handleFilter("classification", e)}
            defaultLabel="All"
            width="auto"
            height="25px"
            isShowHeading
            DropdownHeading="Classification"
            headingColor="#2e8dd3"
          />
        </Col>
        <Col md="auto" xs="12">
          <CustomDropdown
            placeholder="All"
            DropdownLabel="Territory"
            value={props?.filter?.territory}
            onChange={(val: any) => {
              handleFilter("territory", val);
            }}
            fetchData={async ({ page, limit, search }) => {
              const res = await getAllTerritory({
                page,
                search,
                limit,
                OrgUnit: props?.filter?.orgUnit,
              });

              console.log(
                "🚀 ~ SGPIMaster.tsx:404 ~ res:",
                res?.data?.data?.data
              );

              const formatted = res?.data?.data?.data.map((item: any) => ({
                id: item.TerritoryId,
                label: item.TerritoryName,
              }));
              const hasMore =
                Object.keys(res?.data?.data?.data).length === limit;

              return {
                data: formatted,
                hasMore,
              };
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

interface CustomerTableProps {
  setFiltersData: React.Dispatch<any>;
}

const CustomerTable:React.FC<CustomerTableProps> = ({ setFiltersData })  => {
  const location = useLocation();
  const [isEditMode, setIsEditMode] = useState(false);

  const [customerId, setCustomerId] = useState<number | undefined>(undefined);
  const [filtersState, setFiltersState] = useState<any>({
    orgUnit: location?.state?.orgunitId?.OrgunitId || null,
    outletType: null,
    classification: null,
    limit: 10,
    page: 1,
    search: null,
    territory: null,
  });
  useEffect(() => {
  setFiltersData(filtersState);
}, [filtersState]);
 

  const [isModal, setIsModal] = useState(false);
  const [mode, setmode] = useState<"add" | "edit">("add");

  const navigate = useNavigate();
  const { data: customerList,isLoading:isLoading } = useOutletList({
    enabled: true,
    params: {
     
      orgUnit: filtersState.orgUnit || location.state.orgunitId.OrgunitId,
      limit: filtersState.limit,
      page: filtersState.page,
      search: filtersState.search,
      outletType: filtersState.outletType,
      classification: filtersState.classification,
      territory: filtersState.territory,
    },
  });

  const { data: orgUnitsList } = useGetOrgUnitsData({ enable: true });
  const { data: customerOutletType } = useOutletType({ enabled: true });

  const { data: classificationList } = useClassificationListData({
    enable: true,
    params: { fetch: "all" },
  });

  const prependAllOption = (options: any[]) => [
    { id: "null", label: "All" },
    ...options,
  ];

  const formatOptions = (dataObj: Record<string, string> = {}) =>
    Object.keys(dataObj).map((key) => ({ id: key, label: dataObj[key] }));
  const formattedClassification = prependAllOption(
    formatOptions(classificationList?.data?.data?.Classifications)
  );

  const formattedOutletTypes = prependAllOption(customerOutletType?.data || []);

  const CutomerTableColumn = (
    handleEdit: (row: any) => void,
    handleInventory: (row: any) => void
  ) => [
    {
      name: "Org Unit",
      selector: (row: { OrgUnitName: string }) => row.OrgUnitName || "-",
      width: "130px",
      sortable: true,
    },
    {
      name: "Outlet Name",
      sortable: true,

      cell: (row: { OutletName: string; Outlet_Id: number }) => (
        //${row.CustomerID}
        <Link
          to={`/customer/customerProfile`}
          state={{ outletId: row.Outlet_Id }}
          style={{ textDecoration: "none", color: "blue" }}
        >
          {row.OutletName || "-"}
        </Link>
      ),
      width: "130px",
    },
    {
      name: "Outlet Type",
      selector: (row: { OutlettypeName: string }) => row.OutlettypeName || "-",
      width: "130px",
      sortable: true,
    },
    {
      name: "Outlet Town",
      selector: (row: { OutletTown: string }) => row.OutletTown || "-",
      width: "130px",
      sortable: true,
    },

    {
      name: "Outlet Classification",
      sortable: true,
      selector: (row: { Classification: string }) => row.Classification || "-",
    },
    // {
    //   name: "Position",
    //   selector: (row: { PositionName: string }) => row.PositionName || "-",
    //   wrap: true,
    //   width: "130px",
    // },
    {
      name: "Territory",
      selector: (row: { TerritoryName: string }) => row.TerritoryName || "-",
      wrap: true,
      width: "130px",
      sortable: true,
    },

    {
      name: "Contact",
      selector: (row: { OutletIsdCode: string; OutletContactNo: string }) =>
        (row.OutletIsdCode ? row.OutletIsdCode + " " : "") +
        (row.OutletContactNo || "-"),
      wrap: true,
      width: "130px",
      sortable: true,
    },
    {
      name: "Created on",
      selector: (row: { CreatedAt: string }) => row.CreatedAt,
      width: "130px",
      wrap: true,
      sortable: true,
    },
    {
      name: "Actions",
      width: "208px",
      cell: (row: any) => (
        <div
          className="d-flex align-items-center gap-2" /* style={{ display: "flex", gap: "4px" }} */
        >
          <button
            onClick={() => handleEdit(row.Outlet_Id)}
            className="btn btn-primary"
            style={{
              borderRadius: "20px",
              padding: "5px",
              width: "80px",
              display: "flex",
              gap: "2px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
          </button>
          <button
            onClick={() => handleInventory(row)}
            className="btn btn-info"
            style={{
              borderRadius: "20px",
              padding: "5px",
              width: "100px",
              display: "flex",
              gap: "2px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <FaEye size={18} style={{ fill: "#fff" }} />
            Inventory
          </button>
        </div>
      ),
    },
  ];

  const handleEdit = (CstID: number) => {
    setCustomerId(CstID);
    setIsEditMode(true); // Mark as Edit mode
    setIsModal(true);
    setmode("edit");
  };

  const handleInventory = (inventory: any) => {
    navigate("/customer/inventory", {
      state: { OutletID: inventory.Outlet_Id, inventory },
    });
  };

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };

  const oncloseModal = () => {
    setIsModal(false);
  };

  const toggle = () => {
    setIsModal(!isModal);
  };

  return (
    <div className="container-fluid" style={{ padding: "0px" }}>
      <BasicDataTable
      showSpinner={isLoading}
        paginationTotalRows={customerList?.data?.Pagination?.TotalOutlets}
        Title="Customer lists"
        data={customerList?.data?.Outlets}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        columns={CutomerTableColumn(handleEdit, handleInventory)}
        dynamicHeightOnRowsPerPage={true}

        headerContent={
          <HeaderContent
            orgUnitsList={orgUnitsList?.data}
            classification={formattedClassification}
            setFiltersState={setFiltersState}
            filter={filtersState}
            outletType={formattedOutletTypes}
          />
        }
      />
      <RouteModal
        size="xl"
        isOpen={isModal}
        title={mode == "edit" ? "Edit Outlet" : "Add Outlet"}
        toggle={toggle}
        content={
          <CustomerModal
            mode={mode}
            modalClose={oncloseModal}
            customerID={customerId}
          />
        }
      />
    </div>
  );
};
export default CustomerTable;
